import React from "react"
import { Box, Container, Link, Stack, Typography } from "@mui/material"
import { Link as RouterLink } from "react-router-dom"

export const Footer: React.FC = () => {
	const year = new Date().getFullYear()

	return (
		<Box
			component="footer"
			sx={(theme) => ({
				borderTop: `1px solid ${theme.palette.divider}`,
				background: theme.palette.background.paper,
			})}
		>
			<Container
				maxWidth="lg"
				sx={{
					px: { xs: 2, sm: 3, md: 4 },
					py: { xs: 3, sm: 4 },
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: { xs: "column", md: "row" },
						gap: { xs: 2, md: 3 },
						alignItems: { xs: "flex-start", md: "center" },
						justifyContent: "space-between",
					}}
				>
					<Box>
						<Typography sx={{ fontWeight: 800, letterSpacing: 0.3 }}>
							Синяя карта
						</Typography>
						<Typography variant="body2" color="text.secondary">
							Страхование для поездок в Беларусь
						</Typography>
					</Box>
					<Stack
						direction={{ xs: "column", sm: "row" }}
						spacing={2}
						sx={{ flexWrap: "wrap" }}
					>
						<Link component={RouterLink} to="/" color="inherit" underline="hover">
							Главная
						</Link>
						<Link component={RouterLink} to="/policy" color="inherit" underline="hover">
							Оформить синюю карту
						</Link>
						<Link component={RouterLink} to="/tariffs" color="inherit" underline="hover">
							Тарифы
						</Link>
						<Link component={RouterLink} to="/profile" color="inherit" underline="hover">
							Профиль
						</Link>
					</Stack>
				</Box>
				<Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: "block" }}>
					© {year} Синяя карта. Все права защищены.
				</Typography>
			</Container>
		</Box>
	)
}

export default Footer
